/* eslint-disable class-methods-use-this */
import {GameDataFirstGameState} from '@colonist/game-state-types'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums'
import {GameStateEnums, NetworkEnums, PlayerEnums} from '../../../shared/GameEnums'
import {MatchmakingStatusUpdate} from '../../../shared/matchmaking/MatchmakingInterfaces'
import {RoomState} from '../../../shared/RoomState'
import {SocketDataTypes} from '../../../shared/SocketDataTypes'
import {LobbyImage} from '@colonist/types'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend'
import {SocketActionController} from '../../shared/scripts/socket/SocketActionController'
import {UIGameManager} from '../../shared/scripts/ui_game/UIGameManager'
import {UIUrlController} from '../../shared/scripts/ui_html/UIUrlController'
import {UIMManager} from './ui_html/UIMManager'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {BaseError} from '../../../shared/errors/BaseError'
import {logError} from '../../shared/scripts/ui_utils/Utils'
import {clientI18n} from '../../shared/scripts/ClientI18n'
import {UIUtilsEjsVariables} from '../../shared/scripts/UIUtilsEjsVariables'
import {ChatData} from '@colonist/shared-types'
import {SocketMatchmakingSend} from '../../shared/scripts/socket/SocketMatchmakingSend'
import RoomStateGotKickedData = NetworkEnums.RoomStateGotKickedData
import {GameEndData} from '@colonist/game-base-types'
import {UIMGameEndController} from './ui_game/ui_game_end_screen/UIMGameEndController'
import {RoomPlayOrderSelectionData, RoomSeedOrderSelectionData} from '@colonist/lobby-types'
import {ClientUserState} from '../../shared/scripts/ClientUserState'
import {UIMGeneralServicesController} from './UIMGeneralServicesController'
import {UITGameEndController} from './ui_game/ui_game_end_screen/UITGameEndController'
import {UIGameEndController} from '../../shared/scripts/ui_game/ui_game_end_screen/UIGameEndController'

export class UIMSocketEventHandler extends SocketActionController {
    readonly uiGameManager: UIGameManager
    private readonly uiManager: UIMManager

    constructor(uiGameManager: UIGameManager, uiManager: UIMManager, generalServicesController: UIMGeneralServicesController) {
        super(generalServicesController)
        this.uiGameManager = uiGameManager
        this.uiManager = uiManager
    }

    onChatText(chatData: ChatData) {
        const text = clientI18n.t(chatData.text.key, chatData.text.options)
        this.uiGameManager.chatController?.writeToChat(chatData)
        if(this.uiGameManager.chatController != undefined) return
        this.uiManager.createRoomController.receivedChatMessage(chatData.icon ?? LobbyImage.IconColonistHat, text, chatData.username)
    }

    onStateSessionState() {
        const isAccessGameFromLinkHandledByRoom = this.uiManager.createRoomController.isUserOnCreateRoomFlow()
        if(!isAccessGameFromLinkHandledByRoom) {
            UIUrlController.accessGameFromLink(async(roomId) => {
                await SocketLobbySend.accessGameFromLink(roomId)
            })
        }
    }

    onStateCustomRoom(data: RoomState) {
        if(this.uiManager.sceneController.scene == UIMSceneEnum.Game) window.location.reload()
        this.uiManager.mainpageController.headerController.notificationPanelController?.hideNotificationPanel()
        this.uiManager.createRoomController.updateRoomState(data)
    }
    onStateShowPremiumPopup() {
        return
    }
    onSeedOrderSelection(data: RoomSeedOrderSelectionData) {
        return
    }
    onPlayOrderSelection(data: RoomPlayOrderSelectionData) {
        return
    }
    onStateDisplayInfoMessage(data: PlayerEnums.RoomInfoMessage) {
        return
    }
    onStateGotKicked(data: RoomStateGotKickedData) {
        this.uiManager.createRoomController.leaveRoom()
        this.uiManager.fullscreenPageController.closeAllPages()
    }
    onConnectionEstablished(data: GameDataFirstGameState) {
        this.uiManager.fullscreenPageController.closeAllPages()
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game)
        window.location.hash = data.gameSettingId
    }
    onStateInitialPlacement() {
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game)
    }
    onGameEndState(gameEndData: GameEndData, isShownAfterLiveGame?: boolean) {
        super.onGameEndState(gameEndData, isShownAfterLiveGame)

        this.uiGameManager.gameState.isGameOver = true

        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.GameEnd)
        this.uiGameManager.toolTipController.closeTip()

        const isLandscapeMode = !UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        const showPortraitGameEndView = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp

        let endGameController: UIGameEndController | undefined
        if(isLandscapeMode) {
            endGameController = new UIGameEndController(this.uiGameManager, gameEndData.endGameState, gameEndData.isReplayAvailable, gameEndData.rankedUserStates, isShownAfterLiveGame)
        } else if(showPortraitGameEndView) {
            endGameController = new UIMGameEndController(this.uiGameManager, gameEndData.endGameState, gameEndData.isReplayAvailable, gameEndData.rankedUserStates, isShownAfterLiveGame)
        } else {
            endGameController = new UITGameEndController(this.uiGameManager, gameEndData.endGameState, gameEndData.isReplayAvailable, gameEndData.rankedUserStates, isShownAfterLiveGame)
        }

        if(!ClientUserState.userState?.items.hideAds() && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) this.uiManager.vliController.startMatchmakingVideoAd()

        return endGameController
    }
    onMatchmakingUpdate(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        const matchmakingSelectionController = this.uiManager.mainpageController.bodyController.homepageController.matchmakingController
        matchmakingSelectionController.updateMatchmakingStatus(matchmakingStatusUpdate)
    }
    onMatchmakingError(error: BaseError) {
        this.uiManager.mainpageController.bodyController.homepageController.showMatchmakingError(error)
    }
    onMatchmakingShowPreRollAd() {
        SocketMatchmakingSend.finishedWatchingPreRollAdForRankedGameEntry() // hotfix because MM doesn't detect mobile clients properly

        logError('onMatchmakingShowPreRollAd', ['No preroll ads in mobile'])
    }
    onMatchmakingDisableAdblock() {
        logError('onMatchmakingDisableAdblock', ['No ad blocker on mobile'])
    }
    onChannelRoomUpdate(roomData: SocketDataTypes.ChannelRoomUpdate) {
        logError('onChannelRoomUpdate', ['No channel room update on mobile'])
    }

    onRoomListUpdate(data: NetworkEnums.RoomListUpdateData) {
        this.uiManager.mainpageController.bodyController.lobbyController.updateRoomList(data)
    }
}
